import React from 'react';
import LoadingSpinner from './LoadingSpinner';
import { useTheme } from '../../contexts/ThemeContext';

const LoadingOverlay = ({ isLoading }) => {
    const { isDark } = useTheme();

    if (!isLoading) return null;

    return (
        <div className={`
      absolute inset-0 z-50 
      flex items-center justify-center 
      backdrop-blur-sm 
      ${isDark ? 'bg-slate-900/40' : 'bg-white/40'}
      transition-all duration-300
    `}>
            <LoadingSpinner size="medium" />
        </div>
    );
};

export default LoadingOverlay;
